import HomeGoogleAds from "../../../components/advertisement/home-google-ads";
import NewsAndArticleListComponent from "./components/news-and-articles-list.component";

const NewsAndArticleList = () => {
  return (
    <>
      <NewsAndArticleListComponent />
      <div className="container py-4">
        <HomeGoogleAds />
      </div>
    </>
  );
};

export default NewsAndArticleList;
